import { fontList } from '@/local-shared/fonts/base64-fonts.js'
import qrcode from 'yaqrcode'
import base64 from '@/local-shared/mixins/base64'
import { jsPDF } from 'jspdf'
import store from '@/store'
import _ from 'lodash'

export default {
    mixins: [base64],

    data() {
        return {
            user: null,
            teacher: null,
            template: null,
            classes: null,
            enrollment: null,
            course: null,
            certificate: null,

            frontendUrl: process.env.VUE_APP_URL,

            orientation: {
                key: 'p',
            },

            size: {
                key: 'a3',
            },

            mappings: [
                {
                    slug: 'text_content',
                    translation_key: 'templates.text_content',
                    default_value_translation: 'templates.default_text_content',
                },
                {
                    slug: 'image_content',
                    translation_key: 'templates.image_content',
                    default_value_translation: 'templates.image_content',
                },
                {
                    slug: 'student_name',
                    translation_key: 'templates.student_name',
                    default_value_translation: 'templates.default_student_name',
                },
                {
                    slug: 'teacher_name',
                    translation_key: 'templates.teacher_name',
                    default_value_translation: 'templates.default_teacher_name',
                },
                {
                    slug: 'course_name',
                    translation_key: 'templates.course_name',
                    default_value_translation: 'templates.default_course_name',
                },
                {
                    slug: 'current_date',
                    translation_key: 'templates.current_date',
                    default_value_translation: 'templates.default_current_date',
                },
                {
                    slug: 'course_begin_date',
                    translation_key: 'templates.course_begin_date',
                    default_value_translation:
                        'templates.default_course_begin_date',
                },
                {
                    slug: 'course_end_date',
                    translation_key: 'templates.course_end_date',
                    default_value_translation:
                        'templates.default_course_end_date',
                },
                {
                    slug: 'qrcode',
                    translation_key: 'templates.qrcode',
                    default_value_translation: 'templates.qrcode',
                },
                {
                    slug: 'textarea_content',
                    translation_key: 'templates.textarea',
                    default_value_translation: 'templates.textarea',
                },
                {
                    slug: 'evaluation_value',
                    translation_key: 'templates.evaluation_value',
                    default_value_translation:
                        'templates.default_evaluation_value',
                },
                {
                    slug: 'evaluation_status',
                    translation_key: 'templates.evaluation_status',
                    default_value_translation:
                        'templates.default_evaluation_status',
                },
                {
                    slug: 'training_center',
                    translation_key: 'templates.training_center',
                    default_value_translation:
                        'templates.default_training_center',
                },
            ],

            maxWidth: 24,
            maxHeight: 24,

            defaultFontSize: 24,
            defaultFontName: 'ffdin',
            defaultFontStyle: 'normal',

            defaultX: 10,
            defaultY: 10,

            defaultQrCodeSize: 400,
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        },
    },

    methods: {
        async createPdf(
            template,
            demo = true,
            userAux = null,
            teacherAux = null,
            classAux = null,
            courseAux = null,
            enrollmentAux = null,
            certificateAux = null
        ) {
            this.parsePropertiesToObject(template)
            this.user = _.cloneDeep(userAux)
            this.teacher = _.cloneDeep(teacherAux)
            this.classes = _.cloneDeep(classAux)
            this.course = _.cloneDeep(courseAux)
            this.enrollment = _.cloneDeep(enrollmentAux)
            this.certificate = _.cloneDeep(certificateAux)

            if (template.options.orientation == null) {
                template.options.orientation = this.orientation.key
            }

            let doc = new jsPDF(
                template.options.orientation,
                'mm',
                this.size.key
            )

            const width = doc.internal.pageSize.getWidth()
            const height = doc.internal.pageSize.getHeight()

            if (template.data != null) {
                doc.addImage(template.data, 'JPG', 0, 0, width, height)
            }

            if (template.templateInputs != null) {
                for (const element of template.templateInputs) {
                    if (element.destroy != false) {
                        doc.setFontSize(element.size)

                        let font = this.getFont(element.options.font)

                        if (font != null) {
                            doc.setFont(
                                font.slug,
                                element.options.fontStyle
                                    ? element.options.fontStyle
                                    : this.defaultFontStyle
                            )
                        }
                        if (element.options.color) {
                            doc.setTextColor(element.options.color)
                        }

                        if (element.data) {
                            let dimensions = await this.getImageDimensions(
                                element.data
                            )
                            element.width = dimensions.w * element.size
                            element.height = dimensions.h * element.size

                            doc.addImage(
                                element.data,
                                'JPG',
                                Math.round((element.x / 100) * width),
                                Math.round((element.y / 100) * height),
                                element.width,
                                element.height
                            )
                        } else if (element.mapping_id != null) {
                            if (element.mapping_id.slug === 'qrcode') {
                                let qr = null
                                if (demo) {
                                    qr = qrcode('www.google.pt', {
                                        size: this.defaultQrCodeSize,
                                    })
                                } else {
                                    qr = qrcode(
                                        this.frontendUrl +
                                            '/certificate-validation/' +
                                            this.certificate.hash,
                                        {
                                            size: this.defaultQrCodeSize,
                                        }
                                    )
                                }

                                let dimensions = await this.getImageDimensions(
                                    qr
                                )
                                element.width = dimensions.w * element.size
                                element.height = dimensions.h * element.size

                                doc.addImage(
                                    qr,
                                    'JPG',
                                    Math.round((element.x / 100) * width),
                                    Math.round((element.y / 100) * height),
                                    element.width,
                                    element.height
                                )
                            } else if (
                                element.mapping_id.slug === 'text_content'
                            ) {
                                let font = this.getFont(element.options.font)
                                if (font != null) {
                                    doc.setFont(
                                        font.slug,
                                        element.options.fontStyle
                                            ? element.options.fontStyle
                                            : this.defaultFontStyle
                                    )
                                }

                                doc.text(
                                    element.content,
                                    Math.round((element.x / 100) * width),
                                    Math.round((element.y / 100) * height),
                                    element.options != null
                                        ? element.options
                                        : {
                                              align: 'center',
                                          }
                                )
                                doc.setFont(
                                    this.defaultFontName,
                                    this.defaultFontStyle
                                )
                            } else if (
                                element.mapping_id.slug !== 'image_content'
                            ) {
                                doc.text(
                                    this.getMapping(element.mapping_id, demo),
                                    Math.round((element.x / 100) * width),
                                    Math.round((element.y / 100) * height),
                                    element.options != null
                                        ? element.options
                                        : {
                                              align: 'center',
                                          }
                                )
                            } else {
                                doc.text(
                                    this.getMapping(element.mapping_id, demo),
                                    Math.round((element.x / 100) * width),
                                    Math.round((element.y / 100) * height),
                                    element.options != null
                                        ? element.options
                                        : {
                                              align: 'center',
                                          }
                                )
                            }
                        }

                        doc.setFontSize(this.defaultFontSize)
                    }
                }
            }

            if (demo) {
                return doc.output('blob')
            } else {
                doc.save(
                    this.user.first_name +
                        '_' +
                        JSON.parse(this.course.title)[this.locale.key] +
                        '_' +
                        this.$t('general.certificate') +
                        '.pdf'
                )
            }
        },

        getMapping(mapping_id, demo = true) {
            let aux = _.filter(this.mappings, function (element) {
                return element.slug === mapping_id.slug
            })

            if (demo) {
                return this.getMappingValueDemo(aux[0])
            } else {
                return this.getMappingValue(aux[0].slug)
            }
        },

        getMappingValueDemo(value) {
            if (value.slug === 'current_date') {
                return this.getCurrentDate()
            }
            if (
                value.slug === 'course_begin_date' ||
                value.slug === 'course_end_date'
            ) {
                return 'DD/MM/YYYY'
            }
            return this.$t(value.default_value_translation)
        },

        getMappingValue(slug) {
            let result = ''
            switch (slug) {
                case 'student_name':
                    result = this.user.first_name
                    break
                case 'teacher_name':
                    result = this.teacher ? this.teacher.first_name : ''
                    break
                case 'course_name':
                    result = JSON.parse(this.course.title)[this.locale.key]
                    break
                case 'current_date':
                    result = this.getCurrentDate()
                    break
                case 'course_begin_date':
                    // TODO take into account formatting
                    result = this.classes.start_date.substring(0, 10)
                    break
                case 'course_end_date':
                    // TODO take into account formatting
                    result = this.classes.end_date.substring(0, 10)
                    break
                case 'evaluation_value':
                    result = this.enrollment
                        ? this.enrollment.grade.toString()
                        : ''
                    break
                case 'evaluation_status':
                    if (this.enrollment && this.enrollment.approved != null) {
                        result = this.enrollment.approved
                            ? this.$t('evaluation.approved')
                            : this.$t('evaluation.not_approved')
                    }
                    break
                case 'training_center':
                    result = this.classes.businessunits.name || ''
                    break
                default:
                    break
            }
            return result
        },

        getFont(font) {
            if (font == null) {
                return null
            }

            return _.find(fontList, function (element) {
                return element.slug === font
            })
        },

        getCurrentDate() {
            let today = new Date()

            let dd = today.getDate()
            let mm = today.getMonth() + 1
            let yyyy = today.getFullYear()

            if (dd < 10) {
                dd = '0' + dd
            }

            if (mm < 10) {
                mm = '0' + mm
            }

            return dd + '/' + mm + '/' + yyyy
        },

        getImageDimensions(file) {
            let self = this
            return new Promise(function (resolved) {
                var i = new Image()
                i.onload = function () {
                    var ratio = 0 // Used for aspect ratio

                    // Check if the current width is larger than the max
                    if (i.width > self.maxWidth) {
                        ratio = self.maxWidth / i.width // get ratio for scaling image

                        i.height *= ratio // Reset height to match scaled image
                        i.width *= ratio // Reset width to match scaled image
                    }

                    // Check if current height is larger than max
                    if (i.height > self.maxHeight) {
                        ratio = self.maxHeight / i.height // get ratio for scaling image

                        i.width *= ratio // Reset width to match scaled image
                        i.height *= ratio // Reset height to match scaled image
                    }

                    resolved({
                        w: i.width,
                        h: i.height,
                    })
                }

                i.src = file
            })
        },

        parsePropertiesToObject(template) {
            if (template.templateInputs == null) {
                return null
            }

            if (template.data != null && template.data.type === 'Buffer') {
                template.data = this.getBase64Server(template)
            }

            for (const input of template.templateInputs) {
                if (input.options && typeof input.options === 'string') {
                    input.options = JSON.parse(input.options)
                }

                if (input.mapping_id && typeof input.mapping_id === 'string') {
                    input.mapping_id = JSON.parse(input.mapping_id)
                }

                if (input.options && typeof input.options === 'string') {
                    input.options = JSON.parse(input.options)
                }

                if (input.data != null && input.data.type === 'Buffer') {
                    input.data = this.getBase64Server(input)
                }
            }

            if (typeof template.options == 'string') {
                template.options = JSON.parse(template.options)
            }
        },
    },
}
